<template>
  <div class="activeApply active edit">
    <van-cell-group class="">
      <van-cell title="活动名称" @click="showAllActive=!showAllActive">
        <p class="item2 date-time black" v-if="report.campName">{{report.campName}}</p>
        <p class="item2 date-time" v-else>请选择活动名称</p>
        <div slot="right-icon"  class="triangle_border_down" />
      </van-cell>
      <van-cell title="活动日期" v-if="report.U_RangeTime">
        <div class="flex">
          <div class="flex item1" >
            <p class="item1 date-time black" v-if="report.U_RangeTime">{{firstDate}}</p>
            <!--<p class="item1 date-time" v-else>{{firstDate || "请选择"}}</p>-->
            <!--<div slot="right-icon"  class="triangle_border_down" />-->
          </div>
          至
          <van-popup v-model="showDateTime1" position="bottom">
            <van-datetime-picker
              type="date"
              :min-date="new Date()"
              @confirm="getFirstDate"
              @cancel="showDateTime1=!showDateTime1"
            />
          </van-popup>
          <div class="flex item1" >
            <p class="item1 date-time black" v-if="report.U_RangeTime">{{endDate}}</p>
            <!--<p class="item1 date-time" v-else>{{endDate || "请选择"}}</p>-->
            <!--<div slot="right-icon"  class="triangle_border_down" />-->
          </div>
          <van-popup v-model="showDateTime2" position="bottom">
            <van-datetime-picker
              type="date"
              :min-date="new Date()"
              @confirm="getLastDate"
              @cancel="showDateTime2=!showDateTime2"
            />
          </van-popup>
        </div>

      </van-cell>
      <van-cell title="活动地点" v-if="report.U_CampPlace">
        <p class="item2 date-time black" >{{report.U_CampPlace}}</p>
        <!--<van-field placeholder="请输入活动地点" class="item2" v-model="report.U_CampPlace" @input="limitLength(100,'report','U_CampPlace')"/>-->
      </van-cell>
      <van-cell title="预计人数" v-if="report.U_InvitedCnt">
        <p class="item2 date-time black" >{{$numeral(report.U_InvitedCnt).format('0,0')}}</p>
        <!--<van-field placeholder="请输入预计人数" readonly type="number" class="item2"  v-model="report.U_InvitedCnt"  @input="limitLength(100,'report','U_CampPlace')"/>-->
      </van-cell>
      <van-cell title="到场人数" >
        <van-field placeholder="请输入到场人数" type="number" class="item2" v-model="report.U_OnSiteCnt"  @input="limitLength(100,'report','U_OnSiteCnt')"/>
      </van-cell>
      <van-cell title="集客目标">
        <p class="item2 date-time black" >{{$numeral(report.U_FansTarget).format('0,0')}}</p>
        <!--<van-field placeholder="请输入集客目标" type="number" class="item2" v-model="report.U_FansTarget"  @input="limitLength(100,'report','U_FansTarget')"/>-->
      </van-cell>
      <van-cell title="集客人数">
        <van-field placeholder="请输入集客人数" type="number" class="item2" v-model="report.U_CollectionCnt"  @input="limitLength(100,'report','U_CollectionCnt')"/>
      </van-cell>
      <van-cell title="销售目标">
        <van-field placeholder="请输入销售目标" class="item2" v-model="report.U_SalesTarget"/>
      </van-cell>
      <van-cell title="调查问卷">
        <van-radio-group v-model="report.U_Survey" class="flex " >
          <van-radio name="1" class="radio"> 有
            <img
              slot="icon"
              slot-scope="props"
              :src="props.checked ? Icon[0]: Icon[1]"
              class="radioImg"
            >
          </van-radio>
          <van-radio name="0" class="radio"> 无
            <img
              slot="icon"
              slot-scope="props"
              :src="props.checked ? Icon[0]: Icon[1]"
              class="radioImg"
            >
          </van-radio>
          <!--<van-radio name="1" class="radio">有</van-radio>-->
          <!--<van-radio name="2" class="radio">无</van-radio>-->
        </van-radio-group>
      </van-cell>
      <van-cell title="完成人数">
        <van-field placeholder="请输入完成人数" class="item2" v-model="report.U_SurveyCnt"/>
      </van-cell>

    </van-cell-group>


    <van-cell-group class="group group-table">
      <van-cell   >
        <template slot="title">
          <span class="custom-text">实际费用</span>
          <span class="mini-text">（未税{{$numeral(totalBudget.amount||0).format('0,0.00')}}，含税{{$numeral(totalBudget.unamount||0).format('0,0.00')}}）</span>
        </template>
      </van-cell>
      <div class="table van-hairline--surround">
        <div class="table-title flex ">
          <p class="item1">序号</p>
          <p class="item2">名称</p>
          <p class="item1">数量</p>
          <p class="item3">未税费用</p>
          <p class="item3">含税费用</p>
        </div>
        <template v-for="(item,index) in costList">
          <ul class="table-content flex van-hairline--top" @click="yusuanEdit(item,index)">
            <li class="item1 van-hairline--right">{{index+1}}</li>
            <li class="item2 van-hairline--right">{{item.Name}}</li>
            <li class="item1 van-hairline--right">{{$numeral(item.U_Qty).format('0,0')}}</li>
            <li class="item3 van-hairline--right">{{$numeral(item.U_Amount).format('0,0.00')}}</li>
            <li class="item3 flex">
              <p class="item1 van-hairline--right">{{$numeral(item.U_AmountAftTax).format('0,0.00')}}</p>
              <van-icon name="cross" class="close" @click.stop="costList.splice(index,1)"/>
            </li>
          </ul>
        </template>
        <div class="table-content add-table van-hairline--top" @click="yusuanEdit()">
          +添加一栏
        </div>
      </div>
      <div class="clear">
        <p class="upload-img fl" v-for="(img,index) in costImgList">
          <img :src="$config.serverURL+'upload/'+img.U_url" alt="">
          <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px" @click.stop="costImgList.splice(index,1)"/>
        </p>
        <van-uploader :after-read="afterRead" class="upload " multiple>
          <van-icon name="plus" />
          <p>上传发票</p>
        </van-uploader>
      </div>
    </van-cell-group>

    <van-cell-group class="group group-table">
      <van-cell   >
        <template slot="title">
          <span class="custom-text">当天销售情况</span>
        </template>
      </van-cell>
      <div class="table van-hairline--surround">
        <div class="table-title flex ">
          <p class="item2">序号</p>
          <p class="item3">产品一级分类</p>
          <p class="item2">产品名称</p>
          <p class="item3">金额</p>
        </div>
        <template v-for="(item,index) in saleList">
          <ul class="table-content flex van-hairline--top" @click="saleEdit(item,index)">
            <li class="item2 van-hairline--right">{{index+1}}</li>
            <li class="item3 van-hairline--right">{{item.U_ProductClass1 || item.productClass1Name}}</li>
            <li class="item2 van-hairline--right">{{item.U_ProductName}}</li>
            <li class="item3 flex last">
              <p class="item1 van-hairline--right">{{$numeral(item.U_Amount).format('0,0.00')}}</p>
              <van-icon name="cross" class="close" @click.stop="saleList.splice(index,1)"/>
            </li>
          </ul>
        </template>
        <div class="table-content add-table van-hairline--top" @click.stop="saleEdit()">
          +添加一栏
        </div>
      </div>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="活动总结"  >        </van-cell>
      <quillEditImg quillId="U_Summary" :content="report.U_Summary" @change="onEditorChange($event,'U_Summary')"></quillEditImg>
    </van-cell-group>

    <van-cell-group class="group">
      <van-cell title="现场照片"  > </van-cell>
      <div class="clear">
        <p class="upload-img fl" v-for="(img,index) in reportImgList">
          <img :src="$config.serverURL+'upload/'+img.U_url" alt="">
          <van-icon name="clear" class="del-icon" color="#e83c39"  size="20px" @click="reportImgList.splice(index,1)"/>
        </p>
        <van-uploader :after-read="afterRead2" class="upload " multiple>
          <van-icon name="plus" />
          <p>上传图片</p>
        </van-uploader>
      </div>
    </van-cell-group>


    <div class="bottom-btn flex">
      <div class="item1 btn save" @click="sub(campStatus.D)">保存</div>
      <div class="item1 btn sub" @click="sub(campStatus.W)">提交</div>
    </div>

    <dateTime v-model="showDateTime"  @endChange="dateChange"></dateTime>
    <yusuanPop  v-model="showYusuan" @newYusuan="newYusuan" :info="yusuanValue"></yusuanPop>
    <salesPop  v-model="showSales" @newSales="newSales" :info="saleValue"></salesPop>
    <salesPop2  v-model="showSalesmonth" @newSales="newSalesmonth"></salesPop2>
    <allActive v-model="showAllActive" @getAllActive="getAllActive"></allActive>
    <backTo url="/active/reportList"></backTo>
  </div>
</template>
<script>
  import dateTime from './component/datetime.vue'
  import moment from 'moment'
  import yusuanPop from './component/yusuanPop.vue'
  import salesPop from './component/salesPop.vue'
  import allActive from './component/allActive.vue'
  import campKit from '@/common/campKit';
  import quillEditImg from './component/quillEditImg.vue'
  import backTo from './component/backTo.vue'
  import imageCompression from 'browser-image-compression';

  export default{
    data(){
      return {
        report:{
          U_Survey:'1'
        },  //基本信息
        costList:[],  //活动实际费用列表
        costImgList:[], //实际费用列表
        saleList:[], //活动当天销售情况
        saleMonthList:[], //活动三十天后销售情况
        flowRecordList:[], //审批记录
        reportImgList:[],  //现场活动图片列表

        showAllActive:false,//所有活动列表
        showDateTime:false, //活动日期
        showYusuan:false, //实际费用
        yusuanValue:{},
        showSales:false,
        saleValue:{},
        showSalesmonth:false, //一个月后销售

        campStatus:campKit.campStatus,

        currentDate: new Date(),
        firstDate:null, //活动初始时间
        endDate:null, //活动结束时间
        firstDateTs : null, //开始时间戳
        endDateTs : null, //结束时间戳

        showDateTime1:false,
        showDateTime2:false,

        Icon:[ require('@/assets/Sc.png'),require('@/assets/Sn.png')]

      }
    },
    components:{
      dateTime,
      yusuanPop,
      salesPop,
      salesPop2:salesPop,
      allActive,
      quillEditImg,
      backTo
    },
    computed: {
      totalBudget(){//活动预算合计
        let count = 0, amont = 0, unamont = 0
        for (var item of this.costList) {
          count += parseInt(item.U_Qty || 0)
          amont += parseFloat(item.U_Amount || 0)
          unamont += parseFloat(item.U_AmountAftTax || 0)
        }
        let data = {
          count: count, amount:this.$validator().towDecimal(amont+''), unamount: this.$validator().towDecimal(unamont+'')
        }
        return data
      },
    },
    watch:{
      'report.U_RangeTime':function(){
        if(this.report.U_RangeTime){
          this.report.U_RangeTime = this.report.U_RangeTime.replace(',','-')
        }
      }
    },
    methods:{
      getDetail(){
        this.$api.$active.reportDetail({
          salesId:this.$wxuserUtil.getUserId(),
          id:this.$route.query.id
        }).then(response=>{
          if(response.success==true){
            this.report = response.data.report
            this.costList = response.data.costList
            this.costImgList =response.data.costImgList
            this.saleList =response.data.saleList
            this.saleMonthList =response.data.saleMonthList
            this.flowRecordList = response.data.flowRecordList||[]
            this.reportImgList = response.data.reportImgList||[]

            this.firstDate = this.report.U_RangeTime.split(',')[0]
            this.endDate = this.report.U_RangeTime.split(',')[1]

            this.firstDateTs = new Date(this.firstDate).getTime();
            this.endDateTs = new Date(this.endDate).getTime();

            this.isApply =(this.report.U_CreatedId==this.$wxuserUtil.getUserId())
            this.isApproval =(this.report.auditId==this.$wxuserUtil.getUserId())
          }else{
            this.$title(`获取活动详情失败,${response.msg}`);
          }
        })
      },
      dateChange(e){
        this.report.U_RangeTime = moment(e[0]).format('YYYY-MM-DD')+','+moment(e[1]).format('YYYY-MM-DD')
      },
      async afterRead(files){
        console.log(files.constructor)
        if(files.constructor === Array){
          if(files.length>99){
            this.$title('图片不能超过99张')
            return
          }
          for(var item of files){
            await this.onRead(item)

          }
        }else if(files.constructor === Object){
          await this.onRead(files)
        }
        this.$toast.clear()
        this.$title('上传成功')
      },
      async onRead(file){
        var fileSrc = file.file;
        var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
        if(!isImg){
          return;
        }
        this.$toast({
          duration: 0,
          mask: true,
          message: '上传中...'
        });

        let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

        var formData = new FormData()
        formData.append('salesId',this.$wxuserUtil.getUserId());
        formData.append('file',lastFile);

        this.$api.uploadFile(formData).then(response=>{
          if(response.success==true){
            this.costImgList.push({U_url:response.data.fileName})
          }else{
            this.$title(`图片上传失败,${response.msg}`);
          }
        })
      },

      async afterRead2(files){
        console.log(files.constructor)
        if(files.constructor === Array){
          if(files.length>99){
            this.$title('图片不能超过99张')
            return
          }
          for(var item of files){
            await this.onRead2(item)
          }
        }else if(files.constructor === Object){
          await this.onRead2(files)
        }
        this.$toast.clear()
        this.$title('上传成功')
      },
      async onRead2(file){
        var fileSrc = file.file;
        var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
        if(!isImg){
          return;
        }

        this.$toast({
          duration: 0,
          mask: true,
          message: '上传中...'
        });

        let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

        var formData = new FormData()
        formData.append('salesId',this.$wxuserUtil.getUserId())
        formData.append('file',lastFile)
        this.$api.uploadFile(formData).then(response=>{
          if(response.success==true){
            this.reportImgList.push({U_url:response.data.fileName})
          }else{
            this.$title(`图片上传失败,${response.msg}`);
          }
        })
      },
      newYusuan(val){ //新增预算
        let obj = val
        if(!obj.U_Sort){
          obj.U_Sort = this.costList.length+1
          this.costList.push(JSON.parse(JSON.stringify(obj)))
        }else{
          for(var key in this.costList){
            if(obj.U_Sort==this.costList[key].U_Sort){
              this.costList.splice(key,1,obj)
            }
          }
        }
      },
      newSales(val){ //新增预算
        let obj = val
        if(!obj.U_Sort){
          obj.U_Sort = this.saleList.length+1
          this.saleList.push(JSON.parse(JSON.stringify(obj)))
        }else{
          for(var key in this.saleList){
            if(obj.U_Sort==this.saleList[key].U_Sort){
              this.saleList.splice(key,1,obj)
            }
          }
        }
      },
      newSalesmonth(val){ //新增预算
        let obj = val
        this.saleMonthList.push(JSON.parse(JSON.stringify(obj)))
      },
      onEditorChange(editor,name) {
        this.report[name] = editor.html;
      },
      getAllActive(e){
          this.report.campName =e.name
          this.report.U_CampId =e.id
          this.report.U_CampPlace = e.U_CampPlace
          this.report.U_InvitedCnt = e.U_InvitedCnt
          this.report.U_RangeTime = e.U_RangeTime
          this.report.U_FansTarget = e.U_FansTarget
          this.report.U_OnSiteCnt = e.campMemberCnt
          this.report.U_CollectionCnt = e.campMemberCnt
          this.report.U_SalesTarget = e.U_SaleTarget
          this.getActiveDetail(e.id)

          if(this.report.U_RangeTime){
            this.firstDate = this.report.U_RangeTime.split(',')[0]
            this.endDate = this.report.U_RangeTime.split(',')[1]

            this.firstDateTs = new Date(this.firstDate).getTime();
            this.endDateTs = new Date(this.endDate).getTime();
          }

      },
      getFirstDate(e){
        var currentDate = e.getTime();
        if(this.endDateTs && currentDate > this.endDateTs){
          this.$title('活动开始时间不可早于结束时间')
          return
        }
        this.showDateTime1=!this.showDateTime1
        this.firstDateTs = currentDate;
        this.firstDate =moment(e).format('YYYY-MM-DD')
      },
      getLastDate(e){
        var currentDate = e.getTime();

        if(this.firstDateTs && this.firstDateTs> currentDate){
          this.$title('活动开始时间不可早于结束时间')
          return
        }
        this.showDateTime2=!this.showDateTime2
        this.endDateTs = currentDate;
        this.endDate =moment(e).format('YYYY-MM-DD')
      },
      limitLength(len,key1,key2){
        let value = ''
        if(key2){
          value =this.$data[key1][key2]
        }else{
          value =this.$data[key1]
        }
        if(value.length>len){
          if(key2){
            this.$data[key1][key2]=value.slice(0,len)
          }else{
            this.$data[key1]=value.slice(0,len)
          }
        }
      },
      sub(status){
        this.subStatus=status
        console.log(this.report.campName + ":::" + this.report.U_Survey)
        if(!this.report.campName){
          this.$title('请选择活动名称')
          return
        }
        if(this.report.U_OnSiteCnt===''||!/(^[0-9]\d*$)/.test(this.report.U_OnSiteCnt)){
          this.$title('请输入到场人数,且到场人数只能为整数')
          return
        }
        if(this.report.U_CollectionCnt===''||!/(^[0-9]\d*$)/.test(this.report.U_CollectionCnt)){
          this.$title('请输入集客人数,且集客人数只能为整数')
          return
        }
        if(this.report.U_SalesTarget===''||!/(^[0-9]\d*$)/.test(this.report.U_SalesTarget)){
          this.$title('请输入销售目标,且销售目标只能为整数')
          return
        }
        if(this.report.U_Survey==1&&(this.report.U_SurveyCnt===''||!/(^[0-9]\d*$)/.test(this.report.U_SurveyCnt))){
          this.$title('请输入调查问卷完成人数,且调查问卷完成只能为整数')
          return
        }

//        if(campKit.isSubmit(status) && !this.report.U_Summary){
//          this.$title('请填写活动总结')
//          return
//        }
        if(!this.costList||this.costList.length<1){
          this.$title('请输入实际费用')
          return
        }
        if(!this.report.U_Summary){
          this.$title('请填写活动总结')
          return
        }

        if(this.subing){
          this.$title('请勿重复提交')
          return
        }else{
          this.subing =true
        }
        this.$toast({
          duration: 0,
          mask: true,
          message: '活动正在'+(status=="D"?'保存':'提交')+'中，请稍等...'
        });


        let data ={
          "salesId" : this.$wxuserUtil.getUserId(),//销售用户ID，必填
          "campId" : this.report.U_CampId,//活动ID，必填
          "campReportId" : this.$route.query.id,//活动报告ID，修改时必填
          "onSiteCnt" : this.report.U_OnSiteCnt,//到场人数，必填
          "collectionCnt" : this.report.U_CollectionCnt,//集客人数，必填
          "survey" : this.report.U_Survey,//是否有调研问卷 0没有 1有
          "saleTarget" : this.report.U_SalesTarget,//销售目标，必填
          "surveyCnt" : this.report.U_SurveyCnt,//调研问卷完成人数
          "costList" : this.costList,
          "costImgList" : [],
          "salesList" : this.saleList,
          "summary" : this.report.U_Summary,//活动总结，必填
          "onSiteImgList" : [ ],
          "approvalStatus" : status//审批状态 D-草稿、W-待审批，必填
        }
        for(var key in this.costList){
          data.costList[key].campBudgetId =this.costList[key].U_CampBudgetId
          data.costList[key].name =this.costList[key].Name
          data.costList[key].qyt =this.costList[key].U_Qty
          data.costList[key].amount =this.costList[key].U_Amount
          data.costList[key].amountAftTax =this.costList[key].U_AmountAftTax
        }
        for(var key in this.costImgList){ //实际费用图片列表
          data.costImgList.push(this.costImgList[key].U_url)
        }
        for(var key in this.saleList){
          data.salesList[key].productClass1 =this.saleList[key].U_ProductClass1
          data.salesList[key].productName =this.saleList[key].U_ProductName
          data.salesList[key].amount =this.saleList[key].U_Amount
        }
        for(var key in this.reportImgList){ //实际费用图片列表
          data.onSiteImgList.push(this.reportImgList[key].U_url)
        }

        debugger;
        data = JSON.stringify(data)

        this.$api.$active.reportSubmit(data).then(this.submitCallback,this.submitCallback)
      },

      /**
       * 活动提交的回调函数
       * @param response
       */
      submitCallback(response){
        this.subing = false
        this.$toast.clear()
        let status = this.subStatus
        if(response.success){
          if(status=='D') {
            this.$title('活动报告保存成功');
          }else{
            this.$title('活动报告提交成功');
          }
          this.$router.push('/active/reportDetail?id='+response.data)
        }else{
          response = response.responseJSON || response;

          if(status=='D') {
            this.$title(`活动报告保存失败,${response.msg}`);
          }else{
            this.$title(`活动报告提交失败,${response.msg}`);
          }
        }
      },
      yusuanEdit(obj,index){
        if(obj){
          this.yusuanValue=obj
          this.yusuanValue.U_Sort=index+1
        }else{
          this.yusuanValue={}
        }
        this.showYusuan=!this.showYusuan
      },
      saleEdit(obj,index){
        if(obj){
          this.saleValue=obj
          this.saleValue.U_Sort=index+1
        }else{
          this.saleValue={}
        }
        this.showSales=!this.showSales
      },
      getActiveDetail(id){
        this.$api.$active.campaignDetail({
          salesId:this.$wxuserUtil.getUserId(),
          id:id
        }).then(response=>{
          if(response.success==true){
            this.costList = response.data.budgetList
          }else{
            this.$title(`获取活动详情失败,${response.msg}`);
          }
        })
      },
    },
    created(){
      if (this.$route.query.id) {
        this.getDetail()
        window.document.title='修改活动报告'
      }
    }
  }
</script>
<style scoped lang="less" rel="stylesheet/less">
  @import "../../style/pageStyle/pageView-activeDetail.less";
  .radio{
    margin-right:10px;
  }
  .activeDetail .info .van-cell__title{
    width:70px;
    flex:none;
  }
  .group{
    margin-top: 10px;
  }
  .date-time{
    text-align: left;
  }
  .black{
    color:#323233
  }
  .radioImg{
    width:20px;
    height:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/active/reportApply.vue